'use client';

import { usePlausible } from 'next-plausible';
import { usePostHog } from 'posthog-js/react';

import { CTA } from '@/lib/tracking';
import { segment } from '@/lib/tracking/segmentAnalytics';
import { ButtonLink } from '@/ui/Button/ButtonLink';
import { Section } from '@/ui/Section/Section';

import styles from './BiggerNeeds.module.scss';

export function BiggerNeeds() {
    const posthog = usePostHog();
    const plausible = usePlausible();

    const href = '#talk_to_sales';
    const label = 'Contact sales';

    function handleLinkClicked() {
        segment.track(CTA.CLICKED, { href });
        posthog.capture(CTA.CLICKED, { href });
        plausible('CTAs', {
            props: {
                href,
                label,
            },
        });
    }

    return (
        <Section primary="white" className={styles.section}>
            <div className={styles.content}>
                <h3 className={styles.title}>Bigger needs?</h3>
                <p className={styles.description}>
                    You have a nuanced communications strategy that calls for a unique and reliable
                    modern solution.
                </p>
                <p className={styles.description}>
                    Talk to us about curating a plan tailored to the specific needs of your team.
                </p>
            </div>
            <ButtonLink
                className={styles.button}
                href={href}
                onClick={handleLinkClicked}
                size="large"
            >
                {label}
            </ButtonLink>
        </Section>
    );
}
